import ApeironComponent from '@/components/commons/apeiron-component.model';
import { IPersona } from '@/shared/model/persona/persona.model';
import { Coordinador, CoordinadorExtendido } from '@/shared/model/seguimiento/coordinador.model';
import { Component, Prop } from 'vue-property-decorator';
import { Solicitud } from '@/shared/model/solicitud.model';
import { helpers, required } from 'vuelidate/lib/validators';
import { IUsuarioRol } from '@/shared/model/usuarioRol';
import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';

const CORREO = helpers.regex('correo', /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);

const TELEFONO_VALIDO = helpers.withParams({ type: 'telefono' }, function (value: string) {
  if (!value) return true;
  return /^\d{10}$/.test(value);
});

const validations = {
  coordinador: {
    nombre: {
      required,
    },
    usuario: {
      required,
    },
    correo: {
      required,
    },
    cvu: {
      required,
    },
    correoInstitucional: {
      required,
      CORREO,
    },
    correoAlterno: {
      CORREO,
    },
    telefono: {
      TELEFONO_VALIDO,
    },
  },
};

@Component({
  validations,
})
export default class AsociarCoordinadorF1 extends ApeironComponent {
  public coordinador: CoordinadorExtendido = new CoordinadorExtendido();
  public personaSinCorreo = false;
  public coordinadorAnterior: Coordinador = new Coordinador();

  @Prop({ required: true })
  public solicitud!: Solicitud;

  public usuarios: Array<IUsuarioRol> = [];

  public seleccionarCoordinador(persona: IPersona) {
    this.coordinador = new CoordinadorExtendido();
    this.personaSinCorreo = false;
    if (persona.correo == null || persona.correo == undefined || persona.correo.trim() == '') {
      this.personaSinCorreo = true;
      return;
    }
    this.coordinador.cvu = persona.cvu;
    this.coordinador.correo = persona.correo;
    this.coordinador.nombre = (
      (persona.nombre ?? '') +
      ' ' +
      (persona.apellidoPaterno ?? '') +
      ' ' +
      (persona.apellidoMaterno ?? '')
    ).trim();
    this.coordinador.usuario = persona.login;
  }

  public mounted(): void {
    this.coordinadorAnterior = this.solicitud.coordinador ? this.solicitud.coordinador : new Coordinador();
    this.coordinador = this.solicitud.coordinador ? this.solicitud.coordinador : new CoordinadorExtendido();
  }

  public save(): void {
    this.usuarios = this.solicitud.usuarios || [];
    const usuarioRol: IUsuarioRol = {
      cvu: this.coordinador.cvu,
      usuario: this.coordinador.usuario,
      nombreCompleto: this.coordinador.nombre,
      rol: RolAutoridad.COORDINADOR_PROGRAMA,
    };
    if (this.coordinador.cvu != this.coordinadorAnterior.cvu) {
      this.usuarios = this.usuarios.filter(
        usuario => usuario.cvu !== this.coordinadorAnterior.cvu && usuario.rol !== RolAutoridad.COORDINADOR_PROGRAMA
      );
    }
    this.usuarios.push(usuarioRol);
    this.$emit('submit', { coordinador: this.coordinador, usuarios: this.usuarios });
  }
}
